// import Vue from 'vue'
// export const eventBus = new Vue()
import Vue from 'vue'
export default new Vue()